/**
 * Formats a date as relative time (e.g., "2 hours ago") if within one week,
 * otherwise formats as a date with the relative time in tooltip
 * @param {string|Date} date - The date to format
 * @returns {object} - Object with display text and tooltip text
 */
export const formatRelativeTime = (date) => {
  const now = new Date();
  const targetDate = new Date(date);
  const diffInMs = now - targetDate;
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;

  // Format the full date for tooltip
  const fullDateString = targetDate.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });

  // If less than one week, show relative time
  if (diffInMs < oneWeekInMs) {
    let relativeText = '';

    if (diffInMinutes < 1) {
      relativeText = 'Just now';
    } else if (diffInMinutes < 60) {
      relativeText = `${diffInMinutes} minute${
        diffInMinutes === 1 ? '' : 's'
      } ago`;
    } else if (diffInHours < 24) {
      const remainingMinutes = diffInMinutes % 60;
      if (remainingMinutes === 0) {
        relativeText = `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
      } else {
        relativeText = `${diffInHours} hour${
          diffInHours === 1 ? '' : 's'
        } and ${remainingMinutes} minute${
          remainingMinutes === 1 ? '' : 's'
        } ago`;
      }
    } else {
      const remainingHours = diffInHours % 24;
      if (remainingHours === 0) {
        relativeText = `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`;
      } else {
        relativeText = `${diffInDays} day${
          diffInDays === 1 ? '' : 's'
        } and ${remainingHours} hour${remainingHours === 1 ? '' : 's'} ago`;
      }
    }

    return {
      displayText: relativeText,
      tooltipText: fullDateString,
    };
  }

  // If one week or more, show date with relative time in tooltip
  return {
    displayText: fullDateString,
    tooltipText: `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`,
  };
};
